import { render, staticRenderFns } from "./SaveDashboardTemplate.vue?vue&type=template&id=06d56a0c&scoped=true&"
import script from "./SaveDashboardTemplate.ts?vue&type=script&lang=ts&"
export * from "./SaveDashboardTemplate.ts?vue&type=script&lang=ts&"
import style0 from "./SaveDashboardTemplate.scss?vue&type=style&index=0&id=06d56a0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d56a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDialog,VForm,VIcon,VProgressLinear,VRow,VSwitch,VTextField,VTooltip})
